import { render, staticRenderFns } from "./ContainerEmrPDFViewer.vue?vue&type=template&id=84c4e03c&scoped=true"
import script from "./ContainerEmrPDFViewer.vue?vue&type=script&lang=js"
export * from "./ContainerEmrPDFViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c4e03c",
  null
  
)

export default component.exports